import React from "react";
import HomePage from "./components/homepage/Homepage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Services from "./components/offering/OurServices";
import AboutUs from "./components/about/AboutUs";
import ContactUs from "./components/contact/ContactUs";
import Robotics from "./components/Services/Robotics";
import ArtificialIntelligence from "./components/Services/ArtificialIntelligence";
import STEM from "./components/Services/STEM";
import IoT from "./components/Services/IoT";
import ATL from "./components/Services/ATL";
import PMShri from "./components/Services/PMShri";
import Curriculum from "./components/curriculum/Curriculum";
import Products from "./components/products/Products";
import ProductOverview from "./components/pages/ProductOverview";
import ComingSoon from "./components/coming-soon/ComingSoon";

const App = () => {
  return (
    <BrowserRouter>
                <Routes>
                    <Route exact path="/" element={<HomePage />}/>
                    <Route exact path="/home" element={<HomePage />}/>
                    <Route exact path="/services" element={<Services />}/>
                    {/* <Route exact path="/products" element={<Products />}/> */}
                    {/* <Route exact path="/product/:id/:slug" element={<ProductOverview />}/> */}
                    <Route exact path="/about" element={<AboutUs />}/>
                    <Route exact path="/contact" element={<ContactUs />}/>
                    {/* <Route exact path="/robotics" element={<Robotics />}/>
                    <Route exact path="/artificial-intelligence" element={<ArtificialIntelligence />}/>
                    <Route exact path="/stem" element={<STEM />}/>
                    <Route exact path="/internet-of-things" element={<IoT />}/>
                    <Route exact path="/atal-tinkering-labs" element={<ATL />}/>
                    <Route exact path="/pm-shri" element={<PMShri />}/>
                    <Route exact path="/curriculum" element={<Curriculum />}/>
                    <Route exact path="/coming-soon" element={<ComingSoon />}/> */}
                </Routes>
    </BrowserRouter>

  )
}

export default App;
